import { type AnyAction, type Middleware } from 'redux';
import createShowMessage from '../create-show-message';

/** Maps an action type to the message type it should surface. */
type MessageResolvers = Record<string, (action: AnyAction, state: unknown) => string>;

export const createMessageMiddleware =
  ({ resolvers }: { resolvers: MessageResolvers }): Middleware =>
  (store) => {
    const showMessage = createShowMessage(store);

    return (next) => (action: AnyAction) => {
      const resolver = resolvers[action.type];
      if (resolver) {
        showMessage(resolver(action, store.getState()), action.payload);
      }
      next(action);
    };
  };
